// extracted by mini-css-extract-plugin
export default {"fullWidth":"Un-z","image":"Vn-z","lazyLoadPicture":"Wn-z","lazyLoadSpinner":"Xn-z","lazyLoadSpin":"Yn-z","lazyLoadImage":"Zn-z","hasStyledAspectRatio":"_n-z"};